var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTechstaff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 26C51 39.8071 39.8071 51 26 51C12.1929 51 1 39.8071 1 26C1 12.1929 12.1929 1 26 1C39.8071 1 51 12.1929 51 26Z",
    fill: "#3588B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0968 26L32.3942 32.5897L30.9688 30.9426L35.246 26L30.9688 21.0574L32.3942 19.4103L38.0968 26ZM16.754 26L21.0313 30.9426L19.6058 32.5897L13.9032 26L19.6058 19.4103L21.0302 21.0574L16.754 26ZM23.7702 36.4839H21.625L28.2298 15.5161H30.375L23.7702 36.4839Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51 26C51 39.8071 39.8071 51 26 51C12.1929 51 1 39.8071 1 26C1 12.1929 12.1929 1 26 1C39.8071 1 51 12.1929 51 26Z",
    stroke: "white",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0968 26L32.3942 32.5897L30.9688 30.9426L35.246 26L30.9688 21.0574L32.3942 19.4103L38.0968 26ZM16.754 26L21.0313 30.9426L19.6058 32.5897L13.9032 26L19.6058 19.4103L21.0302 21.0574L16.754 26ZM23.7702 36.4839H21.625L28.2298 15.5161H30.375L23.7702 36.4839Z",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechstaff);
export default __webpack_public_path__ + "static/media/techstaff.61472df83a0914123e47b7042902ad7b.svg";
export { ForwardRef as ReactComponent };